<template>
  <div class='h100-40 width-100vw h-scroll'>
    <ejs-grid  ref='grid' height='calc(100vh - 236px)' :dataSource='data' :contextMenu='contextMenuItems'
      :contextMenuOpen='menuBeforeOpenFunc'  :contextMenuClick='menuClickFunc' :selectionSettings='selectionOptions'
      :allowReordering='true' :allowResizing='true' :allowExcelExport='true' :enableVirtualization='false' :enableColumnVirtualization='false'
      :actionComplete='actionComplete'>
      <e-columns>
        <e-column type='checkbox' textAlign='Center' width='66'></e-column>
        <e-column field='id' :visible='false' headerText='ID' :isPrimaryKey='true' width='130'></e-column>
        <e-column field='name'    :headerText='$t("Software.devicegroupname")' textAlign='Center' width='15%' clipMode='EllipsisWithTooltip' ></e-column>
        <e-column field='submask' :headerText='$t("Software.subnetmask")'      textAlign='Center' width='5%'  clipMode='EllipsisWithTooltip' ></e-column>
        <e-column field='gateway' :headerText='$t("Software.gateway")'         textAlign='Center' width='5%'  clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='startIp' :headerText='$t("Software.startipaddr")'     textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' ></e-column>
        <e-column field='endIp'   :headerText='$t("Software.endipaddr")'       textAlign='Center' width='15%' clipMode='EllipsisWithTooltip' ></e-column>
        <e-column field='usage'   :headerText='$t("Software.allocated")'     textAlign='Center' width='15%' clipMode='EllipsisWithTooltip' ></e-column>
        <e-column field='description' :headerText='$t("Software.description")' textAlign='Center' width='15%' clipMode='EllipsisWithTooltip'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager ref='pager' @click='getIpListData()' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>
    <div class="h-system-hide-upload">
      <ejs-uploader ref="importFile" name="importFile" id="importFile" autoUpload="false" allowedExtensions=".xls" :selected="onSelect" :multiple="false"></ejs-uploader>
    </div>
    <CustomDialog ref='dhcpDetail' :element='dhcpDetail.element' :styles='dhcpDetail.style'>
      <template v-slot:dialog-content>
        <GridForDHCPDetail ref='DHCPDetail' :eqtGrpId='eqtGrpId'></GridForDHCPDetail>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import { Reorder, Resize, ExcelExport, ContextMenu } from '@syncfusion/ej2-vue-grids';
import CustomDialog from '../common/CustomDialog';
import GridForDHCPDetail from './GridForDHCPDetail';
import { EventBus } from '../../plugins/eventBus';
import Router from "../../router";

export default {
  name: 'DistributeIpTable',
  components: {
    CustomDialog,
    GridForDHCPDetail
  },
  data() {
    return {
      selectionOptions: { type: 'Multiple' },
      contextMenuItems: [
        {
          text: `${this.$t('Alarm.confirm')}`
        },
        {
          text: `${this.$t('Software.delete')}`
        }
      ],

      page: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 0,
        pageCount: 10
      },
      queryConditions: {
        conditions: '', // 初始化时需获取初始条件
        keywords: '',
      },
      excelFile: [],
      data: [],
      currentAlarmCache: [], // 当前缓存
      MAX_CACHE_LENGTH: 50,
      dhcpDetail: {
        style: {
          width: '800px',
          height: '688px',
          visible: false,
          model: true
        },
        element: {
          title: this.$t('Software.td_detail'),
          target: this.$refs.dhcpDetail,
          refName: 'dhcpDetailElement',
          buttonGroup: [
            { click: this.closeDHCPDetail, buttonModel: { content: this.$t('Pm.cancel') } },
          ],
          isClose: true
        }
      },
      eqtGrpId: ''
    };
  },
  provide: {
    grid: [Reorder, Resize, ExcelExport, ContextMenu]
  },
  methods: {

    /*
      ej2插件bug，当删除掉最后一条数据时，全选框会置灰，重新添加数据后，全选框不会自动变成可用状态，
      需要手动触发两次点击事件
    */
    actionComplete() {
      this.$refs.grid.selectRow(0,true);
      this.$refs.grid.selectRow(0,true);
    },
    menuBeforeOpenFunc(menuArgs) {
      if (!!menuArgs.rowInfo.rowIndex && menuArgs.rowInfo.rowIndex !== 0) {
        menuArgs.cancel = true;
      }
      const childList = menuArgs.element.querySelectorAll('li.e-menu-item');
      if (this.getCheckedData(true).length > 1) {
        childList[childList.length - 1].style.display = 'none';
      } else {
        childList[childList.length - 1].style.display = 'block';
      }
    },
    menuClickFunc(menuArgs) {
      switch (menuArgs.element.innerText) {
        case `${this.$t('Alarm.confirm')}`:
          this.confirmAlarm();
          break;
        case `${this.$t('Software.delete')}`:
          this.clearAlarm();
          break;
        default:
      }
    },
    getColumnsMapper() {
      return (
        `name:${this.$t('Software.devicegroupname')};`
        + `submask:${this.$t('Software.subnetmask')};`
        + `gateway:${this.$t('Software.gateway')};`
        + `startIp:${this.$t('Software.startipaddr')};`
        + `endIp:${this.$t('Software.endipaddr')};`
        + `description:${this.$t('Software.description')};`
      );
    },
    getCheckedData(selectOnly) { // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        console.log(`${this.$t('Software.no_checked')}`);
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        console.log(`${this.$t('Software.too_many_checked')}!`);
        return false;
      }
      return selectedRecords;
    },
    getCheckedVals() {
      const messageNos = [];
      const checkedData = this.getCheckedData(true);
      for (let i = 0; i < checkedData.length; i++) {
        messageNos.push(checkedData[i].id);
      }
      console.log(messageNos);
      return messageNos;
    },
    getIpListData() {
      // 获取表格数据
      const This = this;
      this.$loading.showLoadding(this.$t('Software.dataIsLoading'));
      This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
      This.$axios.post('/lte/eam/dhcp/getEqtGroupData.html', {
        page: {
          pageNo: This.page.pageNo,
          pageSize: This.page.pageSize
        },
        systemId: 1,
        node: {},
        // conditions: This.queryConditions.conditions,
        name: This.queryConditions.keywords
      }).then(response => {
        const result = response.data.resultVal;
        This.page.totalCount = result.totalCount;
        // This.page.pageSize = result.pageSize;
        // This.page.pageNo = result.pageNo;
        // This.page.pageCount = result.totalPages;
        This.data = result.result;
      });
      this.$loading.hideLoadding();
    },
    exportIpListData() {
      const check = this.getCheckedData(true);
      if (!check) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Software.selectAtLeastOne') });
        return;
      }
      const id = [];
      for (let i = 0; i < check.length; i++) {
        id.push(check[i].id);
      }
      const checkParams = id.toString();
      this.$axios.get('/lte/pm/query/testAjax').then((response) => {
        const result = response.data;
        if (result.errorCode == "SUCCESS"){
          window.open(`${window.location.protocol}//${window.location.host}/lte/eam/dhcp/exportESN.html?check=${checkParams}`);
        } else {
          // 路由跳转到登录界面
          sessionStorage.removeItem('principal');
          localStorage.removeItem('mldn-session-id')
          Router.push({
            path: '/login'
          });
          Router.go(1);
        }
      });
    },
    exportTemplate() {

      this.$axios.get('/lte/pm/query/testAjax').then((response) => {
        const result = response.data;
        if (result.errorCode == "SUCCESS"){
          window.open(`${window.location.protocol}//${window.location.host}/lte/eam/dhcp/exportESN.html`);
        } else {
          // 路由跳转到登录界面
          sessionStorage.removeItem('principal');
          localStorage.removeItem('mldn-session-id')
          Router.push({
            path: '/login'
          });
          Router.go(1);
        }
      });
    },
    deleteIpData() {
      const check = this.getCheckedData(true);
      const id = [];
      for (let i = 0; i < check.length; i++) {
        id.push(check[i].id);
      }
      const checkParams = id.toString();
      if (check) {
        this.$layer.confirm({
          msg: this.$t('Common.tips.confirmTip'),
          btn1: {
            msg: this.$t('Common.confirm'),
            func: () => {
              this.$axios.get(`/lte/eam/dhcp/deleteEqtGroup.html?check=${checkParams}`).then(response => {
                const result = response.data.errorCode;
                if (result == 'SUCCESS') {
                  this.getIpListData();
                }
              });
            }
          }
        });
      } else {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Software.selectAtLeastOne') });
      }
    },

    importDHCP() {
      document
        .getElementsByClassName('e-file-select-wrap')[0]
        .querySelector('button')
        .click();
      return false;
    },

    onSelect() {
      const formdata = new FormData();
      const file = document.getElementById('importFile').files[0];
      formdata.append('multipartFile', file);
      this.$loading.showLoadding(this.$t('Software.dataIsLoading'), file.name);
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        timeout: 60 * 6 * 1000
      };
      this.$loading.showLoadding(this.$t('Software.DHCPIsLoading'), file.name);
      this.$axios.post('/lte/eam/dhcp/importESN', formdata, config).then(response => {
        if (response.data.errorCode === 'SUCCESS') {
          EventBus.$emit('toast', { type: 'success', content: this.$t('Software.success') });
          this.getIpListData();
        } else {
          EventBus.$emit('toast', { type: 'error', content: this.$t('Common.tips.failure')});
        }
        this.$loading.hideLoadding();
        // 解决组件添加相同文件不触发onFileSelect bug
        const element = document.getElementsByClassName('e-file-remove-btn')[0];
        element.click();
      });
    },
    showDetail() {
      const check = this.getCheckedData(false);
      if (check.length != 1) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Common.tips.onlyOneSelect') });
        return;
      }
      this.eqtGrpId = check[0].id;
      this.$refs.DHCPDetail.getDHCPDetailData();
      this.$refs.dhcpDetail.show();
    },
    closeDHCPDetail() {
      this.$refs.dhcpDetail.close();
    }
  },
  mounted() {
    this.getIpListData();
  }
};
</script>>
